(function(){
  'use strict';
  var MIN_QUERY_LENGTH=2, DEBOUNCE_MS=200, SKELETON_DELAY_MS=150;

  function escapeRegExp(value){return value.replace(/[.*+?^${}()|[\]\\]/g,'\\$&');}
  function highlightTitle(element,query){
    if(!element)return;
    var title=element.textContent||'';
    var terms=query.trim().split(/\s+/).filter(Boolean).sort(function(a,b){return b.length-a.length;});
    element.textContent='';
    if(!terms.length){element.textContent=title;return;}
    var expression=new RegExp('('+terms.map(escapeRegExp).join('|')+')','gi'),cursor=0;
    title.replace(expression,function(match,_group,offset){
      if(offset>cursor)element.appendChild(document.createTextNode(title.slice(cursor,offset)));
      var mark=document.createElement('mark');mark.textContent=match;element.appendChild(mark);cursor=offset+match.length;return match;
    });
    if(cursor<title.length)element.appendChild(document.createTextNode(title.slice(cursor)));
  }
  function createSkeleton(){
    var wrap=document.createElement('div');wrap.className='hm-predictive-loading';wrap.setAttribute('aria-hidden','true');
    for(var i=0;i<3;i++){var row=document.createElement('div');row.className='hm-predictive-skeleton';wrap.appendChild(row);}return wrap;
  }
  function createError(){var error=document.createElement('div');error.className='hm-predictive-error';error.textContent='Search suggestions are temporarily unavailable. Press Enter to search.';return error;}

  function init(root){
    if(root.dataset.hmPredictiveReady==='true')return;
    root.dataset.hmPredictiveReady='true';
    var form=root.querySelector('[data-hm-search-form]');
    var input=root.querySelector('[data-hm-search-input]');
    var panel=root.querySelector('[data-hm-search-panel]');
    var status=root.querySelector('[data-hm-search-status]');
    var mobileToggle=document.querySelector('[data-hm-mobile-search-toggle]');
    if(!form||!input||!panel)return;

    var timer=null,controller=null,requestNumber=0,cache=new Map();
    var lifecycle=new AbortController(),listenerOptions={signal:lifecycle.signal};

    function setOpen(open){
      panel.hidden=!open;input.setAttribute('aria-expanded',open?'true':'false');
      if(!open){input.removeAttribute('aria-activedescendant');panel.querySelectorAll('[role="option"]').forEach(function(item){item.setAttribute('aria-selected','false');});}
    }
    function announce(message){if(status)status.textContent=message;}
    function close(){setOpen(false);panel.removeAttribute('aria-busy');}
    function closeMobileSearch(){
      root.classList.remove('hm-mobile-open');document.documentElement.classList.remove('hm-mobile-search-open');
      if(mobileToggle)mobileToggle.setAttribute('aria-expanded','false');close();
    }
    function focusables(){return Array.prototype.slice.call(panel.querySelectorAll('[data-hm-focusable]:not([disabled])'));}
    function setActive(item){
      panel.querySelectorAll('[role="option"]').forEach(function(option){option.setAttribute('aria-selected',option===item?'true':'false');});
      if(item&&item.id)input.setAttribute('aria-activedescendant',item.id);else input.removeAttribute('aria-activedescendant');
    }
    function render(fragment,query){
      panel.replaceChildren(fragment);
      panel.querySelectorAll('[data-hm-result-title]').forEach(function(title){highlightTitle(title,query);});
      var countNode=panel.querySelector('[data-hm-predictive-results]');
      var count=countNode?parseInt(countNode.getAttribute('data-hm-result-count')||'0',10):0;
      panel.removeAttribute('aria-busy');setOpen(true);announce(count?count+' product suggestions available.':'No product suggestions found.');
    }
    function fragmentFromHtml(html){
      var parsed=new DOMParser().parseFromString(html,'text/html');
      var results=parsed.querySelector('[data-hm-predictive-results]');
      var fragment=document.createDocumentFragment();if(results)fragment.appendChild(document.importNode(results,true));return fragment;
    }
    function abortRequest(){requestNumber+=1;if(controller){controller.abort();controller=null;}}
    function search(rawQuery){
      var query=rawQuery.trim();
      if(query.length<MIN_QUERY_LENGTH){abortRequest();close();announce('');return;}
      var cacheKey=query.toLowerCase();
      if(cache.has(cacheKey)){render(fragmentFromHtml(cache.get(cacheKey)),query);return;}
      if(controller)controller.abort();
      controller=new AbortController();
      var requestController=controller,activeRequest=++requestNumber;
      panel.setAttribute('aria-busy','true');
      var loadingTimer=setTimeout(function(){if(activeRequest!==requestNumber)return;panel.replaceChildren(createSkeleton());setOpen(true);},SKELETON_DELAY_MS);
      var params=new URLSearchParams();
      params.set('q',query);params.set('section_id','hm-predictive-search');params.set('resources[type]','product');
      params.set('resources[limit]',window.matchMedia('(max-width: 1024px)').matches?'5':'6');
      params.set('resources[options][unavailable_products]','last');params.set('resources[options][fields]','title,product_type,variants.sku');
      fetch('/search/suggest?'+params.toString(),{credentials:'same-origin',headers:{Accept:'text/html'},signal:requestController.signal})
        .then(function(response){if(!response.ok)throw new Error('Predictive search returned '+response.status);return response.text();})
        .then(function(html){
          clearTimeout(loadingTimer);
          if(activeRequest!==requestNumber||query!==input.value.trim())return;
          cache.set(cacheKey,html);if(cache.size>30)cache.delete(cache.keys().next().value);
          render(fragmentFromHtml(html),query);
        })
        .catch(function(error){
          clearTimeout(loadingTimer);if(error.name==='AbortError'||activeRequest!==requestNumber)return;
          panel.replaceChildren(createError());panel.removeAttribute('aria-busy');setOpen(true);
          announce('Search suggestions are unavailable. Press Enter to search.');console.error('HM predictive search:',error);
        })
        .finally(function(){if(controller===requestController)controller=null;});
    }

    input.addEventListener('input',function(){
      clearTimeout(timer);abortRequest();
      var query=input.value.trim();
      if(query.length<MIN_QUERY_LENGTH){close();announce('');return;}
      timer=setTimeout(function(){search(query);},DEBOUNCE_MS);
    },listenerOptions);
    input.addEventListener('focus',function(){if(input.value.trim().length>=MIN_QUERY_LENGTH&&panel.childNodes.length)setOpen(true);},listenerOptions);
    input.addEventListener('keydown',function(event){
      if(event.key==='ArrowDown'&&!panel.hidden){var items=focusables();if(items.length){event.preventDefault();setActive(items[0]);items[0].focus();}}
      else if(event.key==='Escape')close();
    },listenerOptions);
    panel.addEventListener('keydown',function(event){
      var items=focusables(),index=items.indexOf(document.activeElement);
      if(event.key==='ArrowDown'&&items.length){event.preventDefault();var next=items[(index+1+items.length)%items.length];setActive(next);next.focus();}
      else if(event.key==='ArrowUp'&&items.length){event.preventDefault();if(index<=0){setActive(null);input.focus();}else{var previous=items[index-1];setActive(previous);previous.focus();}}
      else if(event.key==='Escape'){event.preventDefault();input.focus();close();}
    },listenerOptions);
    panel.addEventListener('click',function(event){
      var button=event.target.closest('[data-hm-quick-add]');if(!button)return;
      event.preventDefault();var variantId=Number(button.getAttribute('data-variant-id'));
      var card=button.closest('[data-hm-card]'),message=card?card.querySelector('[data-hm-add-message]'):null;
      if(!variantId)return;button.disabled=true;if(message)message.textContent='';
      fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:variantId,quantity:1}]})})
        .then(function(response){if(!response.ok)return response.json().catch(function(){return {};}).then(function(body){throw new Error(body.description||'Could not add');});return response.json();})
        .then(function(){return fetch('/cart.js',{credentials:'same-origin',headers:{Accept:'application/json'}}).then(function(response){return response.json();});})
        .then(function(cart){
          document.dispatchEvent(new CustomEvent('hm:cart:count-updated',{detail:{count:cart.item_count}}));closeMobileSearch();
          document.dispatchEvent(new CustomEvent('hm:cart:open'));
          var cartClose=document.querySelector('[data-hm-cart-close]');if(cartClose)cartClose.focus();
        })
        .catch(function(error){if(message)message.textContent='Could not add';console.error('HM predictive quick add:',error);})
        .finally(function(){button.disabled=false;});
    },listenerOptions);
    document.addEventListener('click',function(event){if(!root.contains(event.target)&&(!mobileToggle||!mobileToggle.contains(event.target))){if(window.matchMedia('(max-width: 1024px)').matches)closeMobileSearch();else close();}},listenerOptions);
    if(mobileToggle){
      mobileToggle.addEventListener('click',function(){
        var open=!root.classList.contains('hm-mobile-open');root.classList.toggle('hm-mobile-open',open);
        document.documentElement.classList.toggle('hm-mobile-search-open',open);mobileToggle.setAttribute('aria-expanded',open?'true':'false');
        if(open)setTimeout(function(){input.focus();},0);else closeMobileSearch();
      },listenerOptions);
    }
    form.addEventListener('submit',function(){close();},listenerOptions);
    window.addEventListener('pagehide',function(){abortRequest();},listenerOptions);
    root.hmPredictiveDestroy=function(){
      clearTimeout(timer);abortRequest();closeMobileSearch();lifecycle.abort();
    };
  }

  function boot(scope){(scope||document).querySelectorAll('[data-hm-predictive-search]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){boot(document);});else boot(document);
  document.addEventListener('shopify:section:load',function(event){boot(event.target);});
  document.addEventListener('shopify:section:unload',function(event){
    event.target.querySelectorAll('[data-hm-predictive-search]').forEach(function(root){if(root.hmPredictiveDestroy)root.hmPredictiveDestroy();});
  });
})();
